import CSS from "./static/css/MovePageButtonIcon.module.css";

const MovePageButtonIcon = () => {
    return(
        <span className={CSS.l_MovePageButtonIcon_main} />
    )
}

export default MovePageButtonIcon;